import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { HrFlexContainer, HrButtons, HrTitleH3 } from '@components/styles/hr-styles';
import { Modal } from '../modal';
import useStore from '../../store/useStore';
import { DisplaySettingsContext } from '../../store/display-settings';

const Image = styled.figure`
  width: 136px;
  height: 136px;
  margin: 0;

  & img {
    width: 136px;
    height: 136px;
    object-fit: cover;
  }
`;

export const SuccessfulUpdate = ({ setShowModal }) => {
  const { getDataPostulant } = useStore();
  const [t] = useTranslation();
  const { darkMode } = useContext(DisplaySettingsContext);

  return (
    <Modal setShowModal={setShowModal} width='360px'>
      <HrFlexContainer flexDirection='column' padding='32px' gap='32px'>
        <Image>
          <img src='/assets/img/ok.png' alt={t('postulant.modal.successful_update.img_alt')} />
        </Image>
        <HrTitleH3 color={darkMode ? 'white' : ''} textAlign='center'>
          {t('postulant.modal.successful_update.title_part_1')} <br />
          {t('postulant.modal.successful_update.title_part_2')}
        </HrTitleH3>
        <HrFlexContainer justifyContent='center' gap='8px'>
          <HrButtons
            category='cancel'
            size='medium'
            onClick={() => {
              setShowModal(false);
            }}
          >
            {t('general.button.close')}
          </HrButtons>
          <HrButtons
            category='primary'
            size='medium'
            onClick={() => {
              window.location.href = getDataPostulant.portalLink;
            }}
          >
            {t('postulant.modal.successful_update.go_to_the_portal')}
          </HrButtons>
        </HrFlexContainer>
      </HrFlexContainer>
    </Modal>
  );
};
